<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 查询管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>h5扫码页面模板管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" icon="el-icon-plus" @click="openEditForm">新建模板</el-button>
            </div>
            <el-divider></el-divider>
            <el-row type="flex" class="row-bg">
                <el-col :span="24">
                    <el-table element-loading-text="拼命加载中" :data="tableData" border
                        style="width:100%">
                        <el-table-column prop="id" label="模板ID" width="60" align="center"></el-table-column>
                        <el-table-column prop="templateName" label="模板名称" min-width="200"></el-table-column>
                        <el-table-column prop="remark" label="备注" min-width="500"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" min-width="200" show-overflow-tooltip>
                            <template slot-scope="props">
                                <el-button-group>
                                    <el-button type="primary" @click="openEditForm(props.row)">修改</el-button>
                                    <el-button type="success" @click="editTemplate(props.row)">编辑模板</el-button>
                                    <el-button type="danger" @click="deleteTemplate(props.row.id)">删除</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                        <el-table-column label="启用状态" min-width="100" show-overflow-tooltip>
                            <template slot-scope="props">
                                <el-switch v-model="props.row.status" active-color="#13ce66" inactive-color="#ff4949"
                                    :active-value="1" :inactive-value="0" @change="activeTemplate(props.row.id)"></el-switch>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>


        <!-- 弹窗框 输入模板名称和备注-->
        <el-dialog title="模板信息" :visible.sync="dialogVisible" width="560px">
            <el-form :model="templateForm" :rules="rules" ref="templateFormRef" label-width="120px">
                <el-form-item label="模板名称" prop="templateName">
                    <el-input v-model="templateForm.templateName" placeholder="请输入模板名称"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" rows="4" v-model="templateForm.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { customPageTemplateList, customPageTemplateSave, activeTemplateStatus, customPageTemplateDelete } from '@/api/qrcode';

export default {
    data() {
        return {
            tableData: [],
            // 模板数据
            templateForm: {
                id: null,
                templateName: '',
                remark: ''
            },
            rules: {
                templateName: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' }
                ],
            },
            dialogVisible: false,
        }
    },
    mounted() {
        this.getTemplateList();
    },
    methods: {
        async getTemplateList() {   
            const res = await customPageTemplateList()  
            if (res.status_code === 200) {
                this.tableData = res.data;
            } 
        },
        openEditForm(row) {
            if (row) {
                this.templateForm = {
                    id: row.id,
                    templateName: row.templateName,
                    remark: row.remark
                };
            } 
            this.dialogVisible = true;
        },
        submit() {
            this.$refs.templateFormRef.validate((valid) => {
                if (valid) {
                    customPageTemplateSave(this.templateForm).then(async res => {
                        if (res.status_code === 200) {
                            this.$message({ message: '提交成功', type: 'success' });
                            this.dialogVisible = false;
                            await this.getTemplateList();
                            
                            // 如果只有一个模板，默认启用该模板
                            if (this.tableData && this.tableData.length === 1) {
                                setTimeout(() => {
                                    this.activeTemplate(this.tableData[0].id);
                                }, 500);
                            }
                        }
                    })
                }
            });
        },
        activeTemplate(templateId) {
            activeTemplateStatus({ templateId: templateId }).then(res => {
                if (res.status_code === 200) {
                    this.$message({ message: '启用成功', type: 'success' });
                    this.getTemplateList();
                }
            })
        },
        deleteTemplate(templateId) {
            this.$confirm('确认删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                customPageTemplateDelete({ templateId: templateId }).then(res => {
                    if (res.status_code === 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getTemplateList();
                    }
                })
            })
        },
        editTemplate(row) {
            this.$router.push({
                path: '/dragpage',
                query: {
                    templateId: row.id
                }
            })
        }
    }
}
</script>

<style scoped></style>